import React, { useState } from "react";
import { FaExclamationTriangle, FaCheckSquare } from "react-icons/fa";
import privateAxios from "../../utils/axiosPrivate";
import PropTypes from "prop-types";
import "./promocode.scss";
import { invoiceTab } from "../../locales/en";
import { getGetInvcsByIdUrl } from "../../utils/constants/apiEndPoints";

const InvPromoCode = ({
  promotitle,
  promoplaceholder,
  promoCode,
  setPromoCode,
  selectInvoices,
  setQuotedData,
  setSelectedInvData,
  setPromoCodeSubmit
}) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [succMessage, setSuccMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handlePromoCodeChange = (e) => {
    const val = e.target.value;
    setPromoCode(val);

    setErrorMessage("");
    if (String(val).trim() === "") {
      setSuccMessage("");
      setSubmitted(false);
    } else {
      setSuccMessage("");
    }
  };

  const handleSubmit = async () => {
    try {
      const invoiceDetails = selectInvoices.map((invoice) => ({
        invoiceId: invoice.id,
        invoiceRepaymentDate: invoice.dueDate
      }));

      const dataToSend = {
        invoiceDetails,
        promoCode: promoCode.trim()
      };

      const response = await privateAxios.post(getGetInvcsByIdUrl, dataToSend);
      const responseData = response?.data?.data;

      if (responseData?.invoices) {
        setQuotedData(responseData.invoices);
        setSelectedInvData(responseData.invoices);
        setPromoCodeSubmit(true);
        setSubmitted(true);

        setErrorMessage("");
        setSuccMessage(
          <>
            <FaCheckSquare />
            {invoiceTab.allinvoiceTable.promoCode.promoApply}
          </>
        );
      } else {
        setErrorMessage(
          <>
            <FaExclamationTriangle />
            {invoiceTab.allinvoiceTable.promoCode.notValidPromo}
          </>
        );
        setSuccMessage("");
        setSubmitted(true);
      }
    } catch {
      setErrorMessage(
        <>
          <FaExclamationTriangle />
          {invoiceTab.allinvoiceTable.promoCode.notValidPromo}
        </>
      );
      setSuccMessage("");
      setSubmitted(true);
    }
  };

  return (
    <div className="promocode-input-wrap mt-2 mb-2">
      <div className="promocode-input-group">
        <div className="promocode-input">
          <span>{promotitle}</span>
          <input
            type="text"
            placeholder={promoplaceholder}
            value={promoCode}
            onChange={handlePromoCodeChange}
          />
          <button
            type="submit"
            className="btn-primary btn"
            onClick={handleSubmit}
            disabled={!promoCode.trim()}
          >
            Apply
          </button>
        </div>

        {submitted && errorMessage && (
          <p className="error-message d-flex align-items-center justify-content-end gap-1">
            {errorMessage}
          </p>
        )}

        {submitted && succMessage && (
          <p className="success-message d-flex align-items-center justify-content-end gap-1">
            {succMessage}
          </p>
        )}
      </div>
    </div>
  );
};

InvPromoCode.propTypes = {
  promotitle: PropTypes.string.isRequired,
  promoplaceholder: PropTypes.string.isRequired,
  promoCode: PropTypes.string.isRequired,
  setPromoCode: PropTypes.func.isRequired,
  selectInvoices: PropTypes.array.isRequired,
  setQuotedData: PropTypes.func.isRequired,
  setSelectedInvData: PropTypes.func.isRequired,
  setPromoCodeSubmit: PropTypes.func.isRequired
};

export default InvPromoCode;
